import * as React from "react";
function SvgBubbleDots(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        d="M29 23h-4v6l-6-6H3a2 2 0 01-2-2V5a2 2 0 012-2h26a2 2 0 012 2v16a2 2 0 01-2 2z"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        stroke="currentColor"
      />
      <circle cx={8} cy={12} r={2} />
      <circle cx={16} cy={12} r={2} />
      <circle cx={24} cy={12} r={2} />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgBubbleDots);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
